import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../assets/images/traceGenomics_no_background.png';
import {
  StyledPanelInfoSection,
  StyledPanelBottomText,
  Logo
} from './AuthStyles';

import { StyledCardPattern } from '../../common/styledComponents/StyledCardPattern';
import { StyledNavigationLink } from '../../common/styledComponents/StyledLink';
import { StyledHeader1, StyledHeader3 } from '../../common/styledComponents/StyledText';

const AuthDualPanel = ({ title, topTitle, form, className = '', lowercase, bottomTextLink }) => (
  <StyledCardPattern
    left={(
      <StyledPanelInfoSection>
        <Logo src={logo} />
        {topTitle && (
          <StyledHeader1 style={{ textAlign: 'center' }} className={`heading ${className}`}>
            {topTitle}
          </StyledHeader1>
        )}
        {lowercase ? (
          <StyledHeader3 style={{ textAlign: 'center' }} className={`heading3 ${className}`}>
            {title}
          </StyledHeader3>
        ) : (
          <StyledHeader1 style={{ textAlign: 'center' }} className={`heading ${className}`}>
            {title}
          </StyledHeader1>
        )}
        {
          bottomTextLink && (
            <StyledPanelBottomText>
              {bottomTextLink === 'register' && 'Don\'t have an account'}
              {bottomTextLink === 'login' && 'Already have an account'}
              ?
              <StyledNavigationLink
                style={{ marginLeft: '10px', fontWeight: 'bold' }}
                color="#008575"
                to={bottomTextLink || ''}
              >
                {bottomTextLink === 'register' && 'Create Account'}
                {bottomTextLink === 'login' &&  'Log In'}
              </StyledNavigationLink>
            </StyledPanelBottomText>
          )
        }
      </StyledPanelInfoSection>
    )}
    right={form}
  />
)

AuthDualPanel.defaultProps = {
  lowercase: false,
  hideBottomText: false
}

AuthDualPanel.propTypes = {
  title: PropTypes.string.isRequired,
  topTitle: PropTypes.string,
  form: PropTypes.node.isRequired,
  className: PropTypes.string,
  lowercase: PropTypes.bool,
  bottomTextLink: PropTypes.string
}

export default AuthDualPanel;
